import { z } from '@/lib/zod'

export function NewsOrderSchema() {
  return z.object({
    sliderSort: z.number().min(0).max(9).optional().default(0),
  })
}

export type NewsOrderForm = z.infer<ReturnType<typeof NewsOrderSchema>>
